<bp-input disabled [value]="address?.getAddress()">
  <a right class="bpi__icon-qr" (click)="openQr()"></a>
  <a
    right
    class="bpi__icon-clipboard"
    [copyToClipboard]="address?.getAddress()"
    preventDefault
  [copyInfo]="'copied_address_to_clipboard' | translate"></a>
  <bp-info full>
    <span>{{ "created_at" | translate }}: {{ address?.getGeneratedAt().date() | bp_date }}</span>
    <div>{{ "last_used_at" | translate }}: {{ address?.getLastUpdated().date() | bp_date }}</div>
  </bp-info>
</bp-input>
<!-- Ripple destination tag -->
@if (address?.getDestinationTag()) {
  <bp-input disabled [value]="address?.getDestinationTag()">
    <a
      right
      class="bpi__icon-clipboard"
      [copyToClipboard]="address?.getDestinationTag()"
      preventDefault
    [copyInfo]="'copied_tag_to_clipboard' | translate"></a>
  </bp-input>
}
<ng-template #qrTemplate>
  <bp-modal-header [title]="'previously_used_coin_address' | translate: [coinSymbol]">
    <a right (click)="closeModal()" class="large-weight" (keydown.enter)="closeModal()" [tabIndex]="0">
      {{ "close" | translate }}
    </a>
  </bp-modal-header>
  <div class="bp-modal-body-section">
    <div class="bp-modal-body-section-info">{{ "crypto-address-text" | translate }}</div>
    <crypto-qr [cssStyle]="'historic'" [address]="address" [coinSymbol]="coinSymbol"></crypto-qr>
  </div>
</ng-template>
